import "./index.scss";

const Details = () => {
  return <div className="full-width details page-wrapper">Coming Soon...</div>;
};

export default Details;
